module.exports = __webpack_public_path__ + "static/media/icon-mail.da835d27.svg";